<template>
  <div
    class="tagIcon"
    :style="'background-color:' + itemData.color"
    @mouseenter="iconHover"
    @mouseleave="iconHoverLeave"
  >
    {{itemData.text}}
  </div>
</template>

<script>
import bus from '@/assets/eventBus'
export default {
  props: ['data'],
  data () {
    return {
      itemData: this.data
    }
  },
  mounted () {
  },
  methods: {
    iconHover () {
      bus.$emit('cursorFocus')
    },
    iconHoverLeave () {
      bus.$emit('cursorFocusRelease')
    }
  }
}

</script>

<style scoped lang="scss">
.tagIcon {
  color: black;
  margin-right: 6px;
  padding: 2px 6px;
  font-size: 16px;
  border-radius: 10px;
  transition: all 0.3s;
}
.tagIcon:hover {
  filter: brightness(150%);
  box-shadow: 0 0 10px white;
  transition: all 0.3s;
}
</style>
